var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080.56 2685.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_6);}.cls-2{opacity:0.7;}.cls-3{fill:url(#Unbenannter_Verlauf_3);}.cls-4{fill:url(#Unbenannter_Verlauf_4);}.cls-5{mask:url(#mask);}.cls-6{fill:url(#Unbenannter_Verlauf_5);}.cls-7{fill:url(#Unbenannter_Verlauf_466);}.cls-8{fill:url(#Unbenannter_Verlauf_8);}.cls-9{fill:#4381a4;}.cls-10{fill:url(#Unbenannter_Verlauf_9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "matrix(0, -531.52, -531.52, 0, 1600190.95, 729.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "matrix(0, -559.06, -559.06, 0, 1683091.07, 591.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99bfe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4381a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "matrix(0, -591.27, -591.27, 0, 1780020.25, 591.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a678c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3a678c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0.56,
    y: 59.75,
    width: 1080,
    height: 531.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.56 -137.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 197.73,
    width: 1080,
    height: 531.52
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_5",
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "matrix(0, -531.52, -531.52, 0, 1600191.5, 591.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005e96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_466",
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "translate(-5343631.91 2144.46) rotate(-90) scale(1775.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f668f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2395cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c83ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_8",
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "matrix(1.91, -1087.2, -1087.2, -1.91, 3272582.17, 7868.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7bb3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7bb3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4381a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_9",
    x1: 0,
    y1: 3009.6,
    x2: 1,
    y2: 3009.6,
    gradientTransform: "matrix(0, -681.93, -681.93, 0, 2052876.02, 2685.83)",
    xlinkHref: "#Unbenannter_Verlauf_8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.56 368.75 0.56 225.81 108.4 242.99 224.13 188.23 383.08 210.4 563.32 128.53 750.87 157.85 906.84 84.03 1080.56 32.21 1080.56 591.27 980.19 552.5 898.19 576.58 785.77 536.65 670.04 574.78 388.35 480.76 270.88 515.92 0.56 368.75"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0.56 368.75 0.56 147.46 58.86 184.01 112.39 165.84 262.81 219.04 378.48 146.99 493.6 179.8 613.98 55.43 931.55 85.36 1080.56 0 1080.56 591.27 980.19 552.5 898.19 576.58 785.77 536.65 670.04 574.78 388.35 480.76 270.88 515.92 0.56 368.75"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.56 368.75 0.56 296.97 100.97 243.51 168.15 265.79 295.4 227.66 411.12 265.79 692.81 171.77 810.28 206.93 1080.56 59.75 1080.56 591.27 980.19 552.5 898.19 576.58 785.77 536.65 670.04 574.78 388.35 480.76 270.88 515.92 0.56 368.75"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1080.56 2003.9 1080.56 591.27 980.19 552.5 898.19 576.58 785.77 536.65 670.04 574.78 388.35 480.76 270.88 515.92 0.56 368.75 0.56 2117.44 120.5 2081.98 230.26 2128.49 356.75 2077.93 503.46 2144.46 708.82 2033 865.37 2106.64 1080.56 2003.9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "0.56 2117.44 0.55 1143.59 98.9 1100.9 183.24 1126.27 293.33 1084.08 409.05 1124.53 690.74 1024.79 808.21 1062.09 1080.56 904.76 1080.56 2003.9 865.37 2106.64 708.82 2033 503.46 2144.46 356.75 2077.93 230.26 2128.49 120.5 2081.98 0.56 2117.44"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "0 1436.64 0.56 2117.44 120.5 2081.98 230.26 2128.49 356.75 2077.93 503.46 2144.46 708.82 2033 865.37 2106.64 1080.56 2003.9 1080.56 1689.55 950.29 1620.2 871.81 1653.45 785.16 1604.54 662.98 1684.05 387.75 1548.65 261.27 1628.18 0 1436.64"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "0.55 2685.83 0.56 2117.44 120.5 2081.98 230.26 2128.49 356.75 2077.93 503.46 2144.46 708.82 2033 865.37 2106.64 1080.56 2003.9 1080.56 2685.83 0.55 2685.83"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/Background.6cdc9640230687bce9b3c37146f1ece5.svg";
export { ForwardRef as ReactComponent };